import * as React from 'react'

import { Card, CardContent } from '../../../components/ui/card'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../../components/ui/tabs'
import { LowConfidenceCard } from './LowConfidenceCard'

/**
 * One graph-curation home for explicit human-review flags and confidence-based
 * triage. Flagged (`valid = false`) entities remain separate because agents
 * treat them as untrusted rather than merely awaiting a decision.
 */
export function ReviewCard({
  defaultView = 'needs-review'
}: {
  defaultView?: 'needs-review' | 'low-confidence'
}): React.ReactElement {
  return (
    <Card className="gap-3 py-4">
      <CardContent className="flex flex-col gap-3">
        <div>
          <h3 className="text-sm font-semibold text-ink">Review</h3>
          <p className="m-0 mt-1 text-xs leading-relaxed text-ink-3">
            Review entities flagged by agents or triage the graph&apos;s lowest-confidence
            extractions.
          </p>
        </div>

        <Tabs defaultValue={defaultView} className="gap-3">
          <TabsList variant="line" className="h-7 w-full justify-start border-b border-line p-0">
            <TabsTrigger
              value="needs-review"
              className="h-7 flex-none rounded-none px-2.5 text-xs after:bottom-[-1px]"
            >
              Needs review
            </TabsTrigger>
            <TabsTrigger
              value="low-confidence"
              className="h-7 flex-none rounded-none px-2.5 text-xs after:bottom-[-1px]"
            >
              Low confidence
            </TabsTrigger>
          </TabsList>
          <TabsContent value="needs-review">
            <LowConfidenceCard embedded mode="needs-review" />
          </TabsContent>
          <TabsContent value="low-confidence">
            <LowConfidenceCard embedded mode="low-confidence" />
          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  )
}
